var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.15 9c2.486 0 4.5-2.014 4.5-4.5S11.636 0 9.15 0a4.499 4.499 0 0 0-4.5 4.5c0 2.486 2.014 4.5 4.5 4.5Zm0 2.25c-3.004 0-9 1.508-9 4.5V18h18v-2.25c0-2.992-5.996-4.5-9-4.5Z"
  })));
};
export default SvgProfile;